import { searchWithHashFallback } from "@src/utils/location";
import { logEvent } from "@src/utils/logClient";

export const SIGNUP_PARAM_STORAGE_KEY = "signupSearchParams";
export const openSignInWindow = ({
  url,
  entrypoint,
}: {
  url: string;
  entrypoint: "login" | "signup" | "consented";
}) => {
  logEvent({
    eventName: "web.parent.google.open",
    eventValue: "sameTab",
  });
  const search = searchWithHashFallback();
  search.set("entrypoint", entrypoint);
  sessionStorage.setItem(SIGNUP_PARAM_STORAGE_KEY, search.toString());
  window.location.href = url;
};
